import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const InsightResponseContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  width: 100%;
  margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
`;

export const InsightHeader = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.margin}px;
  width: 100%;
`;

export const InsightTitle = styled.h2<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  margin: 0;
`;

export const InsightMetadata = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  flex-wrap: wrap;
`;

export const MetadataDot = styled.span<{ theme: { token: GlobalToken } }>`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: ${({ theme: { token } }) => token.colorText};
  display: inline-block;
`;

export const MetadataText = styled.span<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
`;

export const ValueChip = styled.span<{ theme: { token: GlobalToken } }>`
  background: ${({ theme: { token } }) => token.colorFillQuaternary};
  border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  color: ${({ theme: { token } }) => token.colorTextLightSolid};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  height: 24px;
  display: inline-flex;
  align-items: center;
`;

export const InsightDescription = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  white-space: pre-wrap;

  ul {
    margin: ${({ theme: { token } }) => token.marginXS}px 0;
    padding-left: ${({ theme: { token } }) => token.marginLG}px;
  }

  li {
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

export const DescriptionText = styled.div<{ theme: { token: GlobalToken } }>`
  white-space: pre-wrap;
  font-family: ${({ theme: { token } }) => token.fontFamily};
  font-weight: 400;
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  line-height: ${({ theme: { token } }) => token.lineHeight};
  letter-spacing: 0;
`;

export const ActionButtonsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  gap: ${({ theme: { token } }) => token.margin}px;
  flex-wrap: wrap;
`;

export const RecommendedActionsSection = styled.div<{ theme: { token: GlobalToken } }>`
  border-top: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  padding-top: ${({ theme: { token } }) => token.margin}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.margin}px;
`;

export const RecommendedActionsTitle = styled.h3<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  margin: 0;
`;

export const RecommendedActionsList = styled.ul<{ theme: { token: GlobalToken } }>`
  margin: 0;
  padding-left: ${({ theme: { token } }) => token.marginLG}px;
  color: ${({ theme: { token } }) => token.colorText};
  font-family: ${({ theme: { token } }) => token.fontFamily};
  font-weight: 400;
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  line-height: ${({ theme: { token } }) => token.lineHeight};
  letter-spacing: 0;

  li {
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

export const QuickActionsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  flex-wrap: wrap;
`;

export const QuickActionButton = styled.button<{ theme: { token: GlobalToken } }>`
  background: ${({ theme: { token } }) => token.colorBgContainer};
  border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  padding: ${({ theme: { token } }) => token.margin}px;
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme: { token } }) => token.colorFillTertiary};
    border-color: ${({ theme: { token } }) => token.colorPrimary};
  }
`;

export const QuickActionText = styled.span<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
`;
